import React from 'react';
import RipplrGreyLogo from 'assets/grey-ripplr.svg';
import { Text, Flex, Image } from 'atoms';

export default function DenominationFooter() {
	return (
		<Flex flexDirection="column" justifyContent="center" alignItems="center">
			<Image src={RipplrGreyLogo} alt="Ripplr Grey Logo" height={27} width={116} />
			<Text
				maxWidth="150px"
				pt="1rem"
				pb="2rem"
				fontSize="8px"
				textAlign="center"
				lineHeight="11px"
				color="#616060"
			>
				*Denomination will automatically open once all the invoice are filled.
			</Text>
		</Flex>
	);
}
